import { useParams, useLocation } from "react-router-dom";
import RetailerDetailsPanel from "./RetailerDetails";


export default function RetailerDetailsPage() {
  const { id } = useParams();
  const location = useLocation();

  // Data passed from navigate(..., { state: {} })
  const retailer = location.state?.retailer;
  const allRetailers = location.state?.allRetailers;

  return (

    <div className="min-h-screen bg-slate-100">
          <header className="bg-white border-b px-4 py-3">
            <h1 className="text-lg font-semibold text-slate-800 mt-2">
              {/* {pageTitle} */}
            </h1>
    
            <p className="text-xs text-slate-500 hidden md:block">
              Monitor retailers, sales, collections & your own productivity.
            </p>
          </header>
    <div className="p-4">
      <RetailerDetailsPanel
        retailer={retailer}
        allRetailers={allRetailers}
      />
    </div>
    </div>
  );
}
